module.exports = __webpack_public_path__ + "resources/img/img_intermax_2_m.7bd3dbed61f687240882e22bef4da345.png";